// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `



.SubMenu_sidebarLink__sfKXl {
  display: flex;
  color: var(--themeFontColor);
  justify-content: space-between;
  align-items: center;
  padding: 9px 5px;
  text-decoration: none;
  font-size: 13.5px;
  border-radius: 5px;
  font-weight: 500;
  /* margin-top: 3px; */
  /* margin-bottom: 3px; */
  
  

}
.SubMenu_inlinetext__NeXPn{
  display: inline-block !important;
}
.SubMenu_sidebarLink__sfKXl svg {
  fill: #c1c1c1;
  position: relative;
  top: 2px;
}
.SubMenu_sidebarLink__sfKXl:hover {
  background: linear-gradient(225deg,  var(--gradientColor1) 0%, var(--gradientColor2) 91.25%);
  text-decoration: none;
  color: #fff !important;
}
.SubMenu_sidebarLink2__Bu6rF {
  display: block;
  color:var(--themeFontColor);
  justify-content: space-between;
  align-items: center;
  padding: 6px 20px 6px 30px;
  width: 100%;
  text-decoration: none;
  font-size: 14px;
  border-radius: 5px;
  font-weight: 500;
  position: relative;
  margin-top: .2rem;
}
.SubMenu_sidebarLink2__Bu6rF::before {
  content: "";
  background-color: #818093;
  width: 6px;
  height: 6px;
  border-radius: 100%;
  position: absolute;
  left: 15px;
  top: 14px;
}
.SubMenu_sidebarLink2__Bu6rF:hover::before {
  background-color: var(--themeFontColor);
}
.SubMenu_sidebarLink2__Bu6rF:hover {
  background: linear-gradient(225deg,  var(--gradientColor1) 0%, var(--gradientColor2) 91.25%);
  color: #fff;
}

/* For RTL Style */
[dir=rtl] .SubMenu_sidebarLink2__Bu6rF {
  padding: 9px 50px 9px 20px;
}
[dir=rtl] .SubMenu_sidebarLink2__Bu6rF::before {
  left: auto;
  right: 30px;
}

/* For dark mode */
[class="dark"] .SubMenu_sidebarLink__sfKXl, [class="leftsidebardark"] .SubMenu_sidebarLink__sfKXl {
  color: #f3f3f3;
}
[class="dark"] .SubMenu_sidebarLink__sfKXl svg, [class="leftsidebardark"] .SubMenu_sidebarLink__sfKXl svg {
  fill: #f3f3f3;
}
[class="dark"] .SubMenu_sidebarLink__sfKXl span, [class="leftsidebardark"] .SubMenu_sidebarLink__sfKXl svg {
  color: #f3f3f3;
}
[class="dark"] .SubMenu_sidebarLink__sfKXl:hover, [class="leftsidebardark"] .SubMenu_sidebarLink__sfKXl svg {
  color: var(--themeFontColor);
}
[class="dark"] .SubMenu_sidebarLink__sfKXl:hover span, [class="leftsidebardark"] .SubMenu_sidebarLink__sfKXl svg {
  color: var(--themeFontColor);
}
[class="dark"] .SubMenu_sidebarLink__sfKXl:hover svg, [class="leftsidebardark"] .SubMenu_sidebarLink__sfKXl svg {
  fill: var(--themeFontColor);
}

[class="dark"] .SubMenu_sidebarLink2__Bu6rF, [class="leftsidebardark"] .SubMenu_sidebarLink2__Bu6rF {
  color: var(--darkHeadingTextColor);
}
[class="dark"] .SubMenu_sidebarLink2__Bu6rF span, [class="leftsidebardark"] .SubMenu_sidebarLink2__Bu6rF {
  color: var(--darkHeadingTextColor);
}
[class="dark"] .SubMenu_sidebarLink2__Bu6rF:hover, [class="leftsidebardark"] .SubMenu_sidebarLink2__Bu6rF {
  color: var(--themeFontColor);
}
[class="dark"] .SubMenu_sidebarLink2__Bu6rF:hover span, [class="leftsidebardark"] .SubMenu_sidebarLink2__Bu6rF {
  color: var(--themeFontColor);
}`, "",{"version":3,"sources":["webpack://./src/components/Layout/TopSidebar/SubMenu.module.css"],"names":[],"mappings":";;;;AAIA;EACE,aAAa;EACb,4BAA4B;EAC5B,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,wBAAwB;;;;AAI1B;AACA;EACE,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,QAAQ;AACV;AACA;EACE,4FAA4F;EAC5F,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,2BAA2B;EAC3B,8BAA8B;EAC9B,mBAAmB;EACnB,0BAA0B;EAC1B,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,SAAS;AACX;AACA;EACE,uCAAuC;AACzC;AACA;EACE,4FAA4F;EAC5F,WAAW;AACb;;AAEA,kBAAkB;AAClB;EACE,0BAA0B;AAC5B;AACA;EACE,UAAU;EACV,WAAW;AACb;;AAEA,kBAAkB;AAClB;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;AACpC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B","sourcesContent":["\n\n\n\n.sidebarLink {\n  display: flex;\n  color: var(--themeFontColor);\n  justify-content: space-between;\n  align-items: center;\n  padding: 9px 5px;\n  text-decoration: none;\n  font-size: 13.5px;\n  border-radius: 5px;\n  font-weight: 500;\n  /* margin-top: 3px; */\n  /* margin-bottom: 3px; */\n  \n  \n\n}\n.inlinetext{\n  display: inline-block !important;\n}\n.sidebarLink svg {\n  fill: #c1c1c1;\n  position: relative;\n  top: 2px;\n}\n.sidebarLink:hover {\n  background: linear-gradient(225deg,  var(--gradientColor1) 0%, var(--gradientColor2) 91.25%);\n  text-decoration: none;\n  color: #fff !important;\n}\n.sidebarLink2 {\n  display: block;\n  color:var(--themeFontColor);\n  justify-content: space-between;\n  align-items: center;\n  padding: 6px 20px 6px 30px;\n  width: 100%;\n  text-decoration: none;\n  font-size: 14px;\n  border-radius: 5px;\n  font-weight: 500;\n  position: relative;\n  margin-top: .2rem;\n}\n.sidebarLink2::before {\n  content: \"\";\n  background-color: #818093;\n  width: 6px;\n  height: 6px;\n  border-radius: 100%;\n  position: absolute;\n  left: 15px;\n  top: 14px;\n}\n.sidebarLink2:hover::before {\n  background-color: var(--themeFontColor);\n}\n.sidebarLink2:hover {\n  background: linear-gradient(225deg,  var(--gradientColor1) 0%, var(--gradientColor2) 91.25%);\n  color: #fff;\n}\n\n/* For RTL Style */\n[dir=rtl] .sidebarLink2 {\n  padding: 9px 50px 9px 20px;\n}\n[dir=rtl] .sidebarLink2::before {\n  left: auto;\n  right: 30px;\n}\n\n/* For dark mode */\n[class=\"dark\"] .sidebarLink, [class=\"leftsidebardark\"] .sidebarLink {\n  color: #f3f3f3;\n}\n[class=\"dark\"] .sidebarLink svg, [class=\"leftsidebardark\"] .sidebarLink svg {\n  fill: #f3f3f3;\n}\n[class=\"dark\"] .sidebarLink span, [class=\"leftsidebardark\"] .sidebarLink svg {\n  color: #f3f3f3;\n}\n[class=\"dark\"] .sidebarLink:hover, [class=\"leftsidebardark\"] .sidebarLink svg {\n  color: var(--themeFontColor);\n}\n[class=\"dark\"] .sidebarLink:hover span, [class=\"leftsidebardark\"] .sidebarLink svg {\n  color: var(--themeFontColor);\n}\n[class=\"dark\"] .sidebarLink:hover svg, [class=\"leftsidebardark\"] .sidebarLink svg {\n  fill: var(--themeFontColor);\n}\n\n[class=\"dark\"] .sidebarLink2, [class=\"leftsidebardark\"] .sidebarLink2 {\n  color: var(--darkHeadingTextColor);\n}\n[class=\"dark\"] .sidebarLink2 span, [class=\"leftsidebardark\"] .sidebarLink2 {\n  color: var(--darkHeadingTextColor);\n}\n[class=\"dark\"] .sidebarLink2:hover, [class=\"leftsidebardark\"] .sidebarLink2 {\n  color: var(--themeFontColor);\n}\n[class=\"dark\"] .sidebarLink2:hover span, [class=\"leftsidebardark\"] .sidebarLink2 {\n  color: var(--themeFontColor);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sidebarLink": `SubMenu_sidebarLink__sfKXl`,
	"inlinetext": `SubMenu_inlinetext__NeXPn`,
	"sidebarLink2": `SubMenu_sidebarLink2__Bu6rF`
};
export default ___CSS_LOADER_EXPORT___;
